// eslint-disable-next-line eag/match-named-export -- Pre-existing violation
import {FinancialProductType, FinancialProductTypeSchema} from '../../api/types/onlineOfferTypes';

const OPEN_FINANCIAL_PRODUCT_EVENT = 'online-offer:open-financial-product';

/** The sidebar and section are distant siblings; UI intent needs no shared store. */
export function requestOpenFinancialProduct(productType: FinancialProductType): void {
  window.dispatchEvent(new CustomEvent(OPEN_FINANCIAL_PRODUCT_EVENT, {detail: productType}));
}

export function subscribeToOpenFinancialProduct(
  listener: (productType: FinancialProductType) => void
): VoidFunction {
  const handleOpenFinancialProduct = (event: Event) => {
    if (!(event instanceof CustomEvent)) {
      return;
    }

    const productType = FinancialProductTypeSchema.safeParse(event.detail);

    if (productType.success) {
      listener(productType.data);
    }
  };

  window.addEventListener(OPEN_FINANCIAL_PRODUCT_EVENT, handleOpenFinancialProduct);

  return () => window.removeEventListener(OPEN_FINANCIAL_PRODUCT_EVENT, handleOpenFinancialProduct);
}
